<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html, body, #app {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
}

/* ===== 全站统一布局：基于 .page-wrapper（所有列表页根容器） ===== */
.layout-main {
  display: flex !important;
  flex-direction: column !important;
}

/* 页面根容器：占满右侧内容区剩余高度，自身不滚动，把滚动限制在表格 body 内部 */
.page-wrapper {
  flex: 1 1 auto !important;
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
  min-height: 0 !important;
  box-sizing: border-box !important;
  padding: 12px !important;
  overflow: hidden !important;
}

/* 卡片：默认撑满；带 .search-card 类的搜索区卡片固定高度 */
.page-wrapper > .el-card {
  flex: 1 1 auto !important;
  display: flex !important;
  flex-direction: column !important;
  min-height: 0 !important;
}
.page-wrapper > .el-card.search-card { flex: 0 0 auto !important; min-height: 0 !important; }

/* 卡片体：纵向 flex，内部子元素默认不缩放；滚动只在表格 body 内，卡片体不滚动 */
.page-wrapper > .el-card > .el-card__body {
  flex: 1 1 auto !important;
  display: flex !important;
  flex-direction: column !important;
  min-height: 0 !important;
  overflow: hidden !important;
  padding: 12px !important;
  box-sizing: border-box !important;
}
.page-wrapper > .el-card > .el-card__body > * { flex-shrink: 0 !important; }

/* 主表格（含 Tab 内表格）：自身变成纵向 flex，header 固定、body 占满剩余空间 */
.page-wrapper > .el-card > .el-card__body > .el-table,
.page-wrapper > .el-card > .el-card__body > .el-tabs .el-table {
  flex: 1 1 auto !important;
  min-height: 0 !important;
  height: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  position: relative !important;
}
/* 固定列容器也纵向 flex 撑满，避免右侧操作列高度和主表不一致 */
.page-wrapper > .el-card > .el-card__body > .el-table .el-table__fixed,
.page-wrapper > .el-card > .el-card__body > .el-table .el-table__fixed-right,
.page-wrapper > .el-card > .el-card__body > .el-tabs .el-table .el-table__fixed,
.page-wrapper > .el-card > .el-card__body > .el-tabs .el-table .el-table__fixed-right {
  height: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
}
.page-wrapper > .el-card > .el-card__body > .el-table .el-table__fixed .el-table__fixed-header-wrapper,
.page-wrapper > .el-card > .el-card__body > .el-table .el-table__fixed-right .el-table__fixed-header-wrapper,
.page-wrapper > .el-card > .el-card__body > .el-tabs .el-table .el-table__fixed .el-table__fixed-header-wrapper,
.page-wrapper > .el-card > .el-card__body > .el-tabs .el-table .el-table__fixed-right .el-table__fixed-header-wrapper {
  flex-shrink: 0 !important;
}
.page-wrapper > .el-card > .el-card__body > .el-table .el-table__fixed .el-table__fixed-body-wrapper,
.page-wrapper > .el-card > .el-card__body > .el-table .el-table__fixed-right .el-table__fixed-body-wrapper,
.page-wrapper > .el-card > .el-card__body > .el-tabs .el-table .el-table__fixed .el-table__fixed-body-wrapper,
.page-wrapper > .el-card > .el-card__body > .el-tabs .el-table .el-table__fixed-right .el-table__fixed-body-wrapper {
  flex: 1 1 auto !important;
  min-height: 0 !important;
  overflow: hidden !important; /* 固定列不显示独立滚动条，跟随主表滚动 */
}
.page-wrapper > .el-card > .el-card__body > .el-table .el-table__header-wrapper,
.page-wrapper > .el-card > .el-card__body > .el-tabs .el-table .el-table__header-wrapper {
  flex-shrink: 0 !important;
}
.page-wrapper > .el-card > .el-card__body > .el-table .el-table__body-wrapper,
.page-wrapper > .el-card > .el-card__body > .el-table .el-table__fixed-body-wrapper,
.page-wrapper > .el-card > .el-card__body > .el-table .el-table__fixed-right-body-wrapper,
.page-wrapper > .el-card > .el-card__body > .el-tabs .el-table .el-table__body-wrapper,
.page-wrapper > .el-card > .el-card__body > .el-tabs .el-table .el-table__fixed-body-wrapper,
.page-wrapper > .el-card > .el-card__body > .el-tabs .el-table .el-table__fixed-right-body-wrapper {
  flex: 1 1 auto !important;
  min-height: 0 !important;
  overflow-y: auto !important;
}
/* 操作列按钮横向排列不换行，避免固定列内部出现独立滚动 */
.page-wrapper > .el-card > .el-card__body > .el-table .el-table__fixed-right .cell,
.page-wrapper > .el-card > .el-card__body > .el-tabs .el-table .el-table__fixed-right .cell,
.page-wrapper > .el-card > .el-card__body > .el-table .op-col .cell,
.page-wrapper > .el-card > .el-card__body > .el-tabs .el-table .op-col .cell {
  white-space: nowrap !important;
}
.page-wrapper > .el-card > .el-card__body > .el-table .el-table__fixed-right .cell .el-button,
.page-wrapper > .el-card > .el-card__body > .el-tabs .el-table .el-table__fixed-right .cell .el-button,
.page-wrapper > .el-card > .el-card__body > .el-table .op-col .cell .el-button,
.page-wrapper > .el-card > .el-card__body > .el-tabs .el-table .op-col .cell .el-button {
  display: inline-block !important;
  float: none !important;
  white-space: nowrap !important;
  margin-left: 0 !important;
  margin-right: 8px !important;
}
.page-wrapper > .el-card > .el-card__body > .el-table .el-table__fixed-right .cell .el-button:last-child,
.page-wrapper > .el-card > .el-card__body > .el-tabs .el-table .el-table__fixed-right .cell .el-button:last-child,
.page-wrapper > .el-card > .el-card__body > .el-table .op-col .cell .el-button:last-child,
.page-wrapper > .el-card > .el-card__body > .el-tabs .el-table .op-col .cell .el-button:last-child {
  margin-right: 0 !important;
}
/* fallback：不依赖精确祖先结构的操作列防换行 */
.el-table .op-col .cell {
  white-space: nowrap !important;
}
.el-table .op-col .cell .el-button {
  display: inline-block !important;
  float: none !important;
  white-space: nowrap !important;
  margin-left: 0 !important;
  margin-right: 8px !important;
}
.el-table .op-col .cell .el-button:last-child {
  margin-right: 0 !important;
}
/* 无数据时占位块也占满，避免空白 */
.page-wrapper > .el-card > .el-card__body > .el-table .el-table__empty-block,
.page-wrapper > .el-card > .el-card__body > .el-tabs .el-table .el-table__empty-block {
  min-height: 100% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* Tab 页：整体撑满，tab 内容区不滚动，表格 body 内部滚动 */
.page-wrapper > .el-card > .el-card__body > .el-tabs {
  flex: 1 1 auto !important;
  min-height: 0 !important;
  display: flex !important;
  flex-direction: column !important;
}
.page-wrapper > .el-card > .el-card__body > .el-tabs > .el-tabs__content {
  flex: 1 1 auto !important;
  min-height: 0 !important;
  overflow: hidden !important;
}
.page-wrapper > .el-card > .el-card__body > .el-tabs .el-tab-pane {
  height: 100% !important;
  overflow: hidden !important;
}
/* 注意：Element UI 的 tab-pane 没有 is-active class（激活状态靠 v-show 内联 display:none），
   不能用 .is-active 选择器；用 :not([style*="none"]) 匹配当前可见的 pane。
   不能直接给所有 pane 设 display:flex !important，否则会覆盖 v-show 的 display:none 导致所有 tab 同时显示 */
.page-wrapper > .el-card > .el-card__body > .el-tabs .el-tab-pane:not([style*="none"]) {
  display: flex !important;
  flex-direction: column !important;
}

/* Tab 内直接放置的表格占满剩余空间，避免把分页挤出可视区 */
.page-wrapper > .el-card > .el-card__body > .el-tabs .el-tab-pane:not([style*="none"]) > .el-table {
  flex: 1 1 auto !important;
  min-height: 0 !important;
}

/* 分页栏：贴底、右对齐（包含 Tab 内分页） */
.page-wrapper > .el-card > .el-card__body > .pagination,
.page-wrapper > .el-card > .el-card__body > .pagination-wrap,
.page-wrapper > .el-card > .el-card__body > .el-tabs .el-tab-pane:not([style*="none"]) > .pagination,
.page-wrapper > .el-card > .el-card__body > .el-tabs .el-tab-pane:not([style*="none"]) > .pagination-wrap {
  flex-shrink: 0 !important;
  margin-top: 8px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-end !important;
  width: 100% !important;
}
</style>
